<template>
  <div class="container about mt-5" id="about">
    <div class="row align-items-center justify-content-center g-md-5">
      <div class="col-12 col-md-5 d-flex align-items-start align-items-md-center mt-0">
        <img src="../assets/photo/about/mypic.png" alt="" class="w-100 propic" />
      </div>
      <div class="col-12 col-md-5 mt-3 mt-md-0 about-text">
        <div class="">
          <h5 class="text-black-50">About Me</h5>
          <h3 class="fw-bold my-3">Why should you hire me for your next project?</h3>
          <div class="p-3 blur-light rounded shadow">
            <p>I have the excellence of creating upstanding designs of novelty. I firmly believe that these qualities make me different.</p>
            <p>I'm highly skilled with HTML5, CSS3, Javascript, VueJS, and PHP (Laravel) as I have handsome experience with them. Still, I'm eager to learn anew and make my skills sharper whenever I get chane.</p>
          </div>
          <div class="mt-3 d-flex align-items-center justify-content-around">
            <a class="btn btn-primary d-flex justify-content-between align-items-center" download="Htet Aung Hlaing Web Developer CV.pdf" href="/file/Htet_Aung_Hlaing_Web_Developer_CV.pdf">
              <span class="me-3">Download CV</span>
              <lottie-player src="https://assets9.lottiefiles.com/packages/lf20_waha8ys2.json" background="transparent" speed="1.2" style="width: 30px; height: 30px" loop autoplay></lottie-player>
            </a>
            <a class="btn btn-outline-primary" href="phone:+959964949662"
              >Call Me
              <span><i class="bi bi-phone"></i></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    let downloadItem = async ({ url, label }) => {
      const response = await axios.get(url, { responseType: "blob" });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = label;
      link.click();
      URL.revokeObjectURL(link.href);
    };
    return { downloadItem };
  },
};
</script>

<style lang="scss" scoped></style>
